import { render, staticRenderFns } from "./UploadSpeadSheet.vue?vue&type=template&id=245068cf&scoped=true&class=spreadsheetuploadfile&"
import script from "./UploadSpeadSheet.vue?vue&type=script&lang=js&"
export * from "./UploadSpeadSheet.vue?vue&type=script&lang=js&"
import style0 from "./UploadSpeadSheet.vue?vue&type=style&index=0&id=245068cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245068cf",
  null
  
)

export default component.exports